import type { FC } from 'react';

interface LogoProps {
  [key: string]: any;
}

const Logo: FC<LogoProps> = (props) => {
  return <img alt="Logo" height="35" src="/static/riw-logo.svg" {...props} />;
};

export default Logo;
